// src/shared/utils/resizeObserverGuard.ts
const RESIZE_OBSERVER_ERRORS = [
    "ResizeObserver loop completed with undelivered notifications",
    "ResizeObserver loop limit exceeded",
];
function isResizeObserverError(value: unknown): boolean {
    const text = typeof value === "string"
        ? value
        : value instanceof Error
            ? value.message
            : String(value ?? "");
    return RESIZE_OBSERVER_ERRORS.some((msg) => text.includes(msg));
}
/**
 * 1) Гасим window error ДО react-error-overlay.
 */
window.addEventListener("error", (event) => {
    if (isResizeObserverError(event.message) || isResizeObserverError(event.error)) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        return false;
    }
}, true);
/**
 * 2) Гасим promise rejection.
 */
window.addEventListener("unhandledrejection", (event) => {
    if (isResizeObserverError(event.reason)) {
        event.preventDefault();
        event.stopPropagation();
        return false;
    }
}, true);
/**
 * 3) Гасим console.error, потому что webpack/react-error-overlay
 * иногда прокидывает ResizeObserver warning именно через console.
 */
const originalConsoleError = console.error;
console.error = (...args: unknown[]) => {
    if (args.some(isResizeObserverError)) {
        return;
    }
    originalConsoleError(...args);
};
/**
 * 4) Патчим ResizeObserver: callback переносим в requestAnimationFrame.
 * Это уменьшает саму причину loop warning у Recharts / ResponsiveContainer.
 */
const OriginalResizeObserver = window.ResizeObserver;
if (OriginalResizeObserver) {
    window.ResizeObserver = class ResizeObserver extends OriginalResizeObserver {
        constructor(callback: ResizeObserverCallback) {
            super((entries, observer) => {
                window.requestAnimationFrame(() => {
                    callback(entries, observer);
                });
            });
        }
    };
}
export {};
